import { z } from 'zod';
import { message } from './messages.js';
/**
 * Chybove odpovedi API = RFC 9457 application/problem+json s traceId
 * (CLAUDE.md 3). Zasada: 5xx NIKDY nepusti detail, stack ani SQL ven -
 * plna chyba jde jen do serveroveho logu (req.log.error). Prevod konretni
 * vyjimky na Problem dela error handler v apps/api (muze cit typy identity).
 */
export const PROBLEM_CONTENT_TYPE = 'application/problem+json';
export const PROBLEM_TYPE_BASE = 'https://docs.reos.local/errors/';
export const problemSchema = z.object({
    type: z.string(),
    title: z.string(),
    status: z.number().int(),
    detail: z.string().optional(),
    instance: z.string().optional(),
    traceId: z.string(),
    issues: z.array(z.object({ path: z.string(), code: z.string() })).optional(),
});
/**
 * Sestavi problem+json payload dle kodu z katalogu zprav a jazyka kontextu.
 * `titleOverride` slouzi pro domeny chyby s vlastnim titulkem (napr.
 * ProblemError z identity), kod `type` zustava stabilni pro klienty.
 */
export function makeProblem(status, key, traceId, locale, options = {}) {
    const problem = {
        type: options.typeOverride ?? `${PROBLEM_TYPE_BASE}${key}`,
        title: options.titleOverride ?? message(key, locale),
        status,
        traceId,
    };
    if (options.detail !== undefined)
        problem.detail = options.detail;
    if (options.instance !== undefined)
        problem.instance = options.instance;
    if (options.issues !== undefined && options.issues.length > 0) {
        problem.issues = options.issues.map((issue) => ({ path: issue.path, code: issue.code }));
    }
    return problem;
}
/** Mapuje zod issues na strojove kody (path + zod kod, bez textu knihovny). */
export function issuesFromZodError(error) {
    return error.issues.map((issue) => ({
        path: issue.path.map((segment) => String(segment)).join('.') || '(root)',
        code: issue.code ?? 'invalid',
    }));
}
//# sourceMappingURL=problem.js.map